import { render, staticRenderFns } from "./RequestTransfers.vue?vue&type=template&id=b9c34d5e"
import script from "./RequestTransfers.vue?vue&type=script&lang=js"
export * from "./RequestTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports